export default {
    get_research: state => { return state.launch},
    get_reset_invoice_list: state => { return state.reset_invoice_list},
    get_tnfac: state => { return state.tnfac},
    get_fdate_fact: state => {return state.fdate_fact},
    get_tnfac_selected: state => {return state.tnfac_selected},
    get_fncde: state => {return state.fncde},

    get_delivery_pnbl: state => {return state.delivery_pnbl},
    
    // Getters du formulaire des BL
    get_launch_delivery_research: state => {return state.launch_delivery_research},
    get_reset_delivery_list: state => {return state.reset_delivery_list},
    get_delivery_tnbl: state => {return state.delivery_tnbl},
    get_delivery_tnfact: state => {return state.delivery_tnfact},
    get_delivery_tdate_bl: state => {return state.delivery_tdate_bl},
    get_delivery_fncde: state => {return state.delivery_fncde},

    // Getters du formulaire du détail d'un BL
    get_delivery_details_tmod: state => {return state.delivery_details_tmod},
    get_delivery_details_tcol: state => {return state.delivery_details_tcol},
    get_delivery_details_ttaille: state => {return state.delivery_details_ttaille},
    get_delivery_details_trefc: state => {return state.delivery_details_trefc},
    get_launch_delivery_details_research: state => {return state.launch_delivery_details_research},
};